export default __webpack_public_path__ + "static/media/Ring of Broken Promises.e75c5059.jpg";